export const generateId = (): string => crypto.randomUUID();
